import config from 'config';

const MAPPLS_WEB_SDK_ID = 'mappls-web-sdk';
const MAPPLS_SEARCH_PLUGIN_ID = 'mappls-search-plugin-sdk';
const MAPPLS_VERSION = '3.0';

let webSdkPromise = null;
let searchPluginPromise = null;

const buildUrl = (baseUrl, params) => {
  const qs = new URLSearchParams(params);
  console.log('buildUrl >>', `${baseUrl}?${qs.toString()}`);
  return `${baseUrl}?${qs.toString()}`;
};

const getMapplsAccessToken = () => config.mapplsAccessToken || '';

const appendScript = ({ id, src, isReady }) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return Promise.reject(new Error('Mappls can only be loaded in a browser'));
  }

  if (isReady()) {
    return Promise.resolve(window.mappls);
  }

  const existingScript = document.getElementById(id);
  if (existingScript) {
    return new Promise((resolve, reject) => {
      existingScript.addEventListener('load', () => resolve(window.mappls), { once: true });
      existingScript.addEventListener('error', () => reject(new Error(`Unable to load ${src}`)), { once: true });
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.onload = () => resolve(window.mappls);
    script.onerror = () => reject(new Error(`Unable to load ${src}`));
    document.head.appendChild(script);
  });
};

export const loadMapplsWebSdk = () => {
  const accessToken = getMapplsAccessToken();

  if (!accessToken) {
    return Promise.reject(new Error('Missing REACT_APP_MAPPLS_ACCESS_TOKEN'));
  }

  if (!webSdkPromise) {
    const src = buildUrl('https://sdk.mappls.com/map/sdk/web', {
      v: MAPPLS_VERSION,
      access_token: accessToken,
    });

    webSdkPromise = appendScript({
      id: MAPPLS_WEB_SDK_ID,
      src,
      isReady: () => Boolean(window.mappls && window.mappls.Map),
    });
  }

  return webSdkPromise;
};

export const loadMapplsSearchPlugin = () => {
  const accessToken = getMapplsAccessToken();

  if (!accessToken) {
    return Promise.reject(new Error('Missing REACT_APP_MAPPLS_ACCESS_TOKEN'));
  }

  if (!searchPluginPromise) {
    searchPluginPromise = loadMapplsWebSdk().then(() => {
      const src = buildUrl('https://sdk.mappls.com/map/sdk/plugins', {
        access_token: accessToken,
        v: MAPPLS_VERSION,
        libraries: 'search',
      });

      return appendScript({
        id: MAPPLS_SEARCH_PLUGIN_ID,
        src,
        isReady: () => Boolean(window.mappls && window.mappls.search),
      });
    });
  }

  return searchPluginPromise;
};
